import React from "react";
import classNames from "classnames";
import styles from "./Grid.module.scss";

interface GridRowProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    className?: string;
    /** Custom gap between columns (e.g. "12px", "1rem"). Overrides the default. */
    gap?: React.CSSProperties["gap"];
}

export const GridRow: React.FC<GridRowProps> = ({
    children,
    className,
    gap,
    style,
    ...rest
}) => (
    <div
        className={classNames(styles.gridRow, className)}
        style={
            gap !== undefined
                ? ({ ...style, "--grid-gap": gap } as React.CSSProperties)
                : style
        }
        {...rest}
    >
        {children}
    </div>
);

GridRow.displayName = "GridRow";
